module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/more-topic-3-mobile.9bd4fef4.mp4";